// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import WeVue from 'we-vue'
import 'we-vue/lib/style.css'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/index.js'

import NutUI from '@nutui/nutui';
import '@nutui/nutui/dist/nutui.css';
import Mint from 'mint-ui';
import 'mint-ui/lib/style.css';
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import store from './store'
import Vuex from 'vuex'
import './assets/icon/iconfont.css'

import Cookies from 'js-cookie';
import WXConfig from './assets/js/wxshare' // 微信分享
import common from '../common/common.js'
import SIdentify from './components/identify' //注意引入路径
import axios from 'axios'
axios.defaults.baseURL = process.env.API_ROOT
Vue.prototype.$axios = axios
Vue.prototype.WXConfig = WXConfig
Object.defineProperty(Vue.prototype, "$Cookies", { value: Cookies })
Vue.prototype.common = common
Vue.use(Vuex)
Vue.use(ElementUI)
Vue.use(SIdentify)
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999
  }
})
Vue.use(Mint);
NutUI.install(Vue);
Vue.use(WeVue)
Vue.config.productionTip = false
Vue.component(

)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})

router.beforeEach((to, from, next) => {
  //获取用户登录成功后储存的登录标志
  let getFlag = localStorage.getItem("Flag");
  //如果登录标志存在且为isLogin，即用户已登录
  if(getFlag === "isLogin"){
    //设置vuex登录状态为已登录
    store.state.isLogin = true
    next()
    if (!to.meta.isLogin) {
        if(to.name=="myTZ"){
          next({
            path: '/myTZ',
          })
        }
        if(to.name=="tieZi"){
          next({
            path: '/tieZi',
          })
        }
    }
    //如果登录标志不存在，即未登录
  }else{
    //用户想进入需要登录的页面，则定向回登录界面
    if(to.meta.isLogin){
      next({
        path: '/login',
        query: {redirect: to.fullPath}  // 将跳转的路由path作为参数，登录成功后跳转到该路由

      })

    }else{
      next()
    }

  }
});



// WEBPACK FOOTER //
// ./src/main.js